module.exports = __webpack_public_path__ + "img/border_rightTriangle.0f0648c1.svg";